export default __webpack_public_path__ + "static/media/actionServo.ab1fa6a9.svg";